module.exports = __webpack_public_path__ + "static/media/communication-smart.cff9473f.svg";